/*
Loons Lab Date picker component
Developed By Roshan
Loons Lab
*/
import React, { Fragment, Component } from "react";
import { Typography } from '@material-ui/core'
import { any } from "prop-types";
import { themeColors } from 'app/components/MatxTheme/themeColors'
import { MatxLayoutSettings } from 'app/components/MatxLayout/settings'

class CardTitle extends Component {
    static propTypes = {
        style: any,
        title: any
    };

    static defaultProps = {
        title: null,
        style: null
    };



    render() {
        const {
            title,
            style
        } = this.props;
        let activeTheme = MatxLayoutSettings.activeTheme
        let combinedStyle = { ...style, ...{ color: themeColors[activeTheme].palette.subTitleTextColor } }
        return (
            <Fragment>
                <Typography variant="h6" style={combinedStyle} className="font-semibold">{title}</Typography>
                {/*  <Divider /> */}
                <div className="w-full main-title-underline"></div>
            </Fragment>

        );
    }
}

export default CardTitle;